import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import React from "react";
import { ExamSessionCandidateExamState } from "../../../model/examSessionCandidate/ExamSessionCandidateExamViewModel";

interface ExamSessionCandidateExamGradeProps {
  disabled?: boolean;
  examState: ExamSessionCandidateExamState;
  grade?: number | null;
  gradeChange: (score?: number | null) => void;
}

const ExamSessionCandidateExamGrade: React.FunctionComponent<ExamSessionCandidateExamGradeProps> = ({
  disabled,
  examState,
  grade,
  gradeChange,
}) => {
  const handleGradeChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const examGrade = parseFloat(event.target.value);
    gradeChange(isNaN(examGrade) ? null : examGrade);
  };

  if (examState === ExamSessionCandidateExamState.Cancelled) {
    return (
      <Typography variant="body1" component="span">
        -
      </Typography>
    );
  }

  const value = grade === undefined || grade === null ? "" : grade;
  return (
    <TextField
      fullWidth={true}
      disabled={disabled}
      inputProps={{
        min: 1,
        max: 6,
        step: 0.5,
      }}
      type="number"
      onChange={handleGradeChange}
      value={value}
    />
  );
};

export default ExamSessionCandidateExamGrade;
